import React from 'react';
import { AlertTriangleIcon, RotateCcwIcon } from 'lucide-react';
interface ErrorStateProps {
  onRetry: () => void;
  onBack: () => void;
}
export function ErrorState({
  onRetry,
  onBack
}: ErrorStateProps) {
  return <div className="px-6 py-10 text-center" role="alert" data-id="element-59" data-mp="2xqcwy04hyyem">
      <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-600 ring-8 ring-red-50/60" data-id="element-60" data-mp="32pzaybs5gioh">
        <AlertTriangleIcon className="h-7 w-7" aria-hidden="true" data-id="element-61" data-mp="2nrx33pe35b1f" />
      </span>
      <h2 className="mt-5 text-lg font-semibold text-ink-900" data-id="element-62" data-mp="2sskx8jxm27zv">
        We couldn't save this payment
      </h2>
      <p className="mx-auto mt-1 max-w-md text-sm text-ink-500" data-id="element-63" data-mp="2etbqsbz7is93">
        The pay period was locked by payroll while you were entering this line item.
        Nothing was saved — retry, or go back and adjust the entry.
      </p>
      <p className="numeric mx-auto mt-4 max-w-md rounded-md bg-ink-50 px-3 py-2 text-left text-xs text-ink-500" data-id="element-64" data-mp="d1ovhy8a8b6t">
        FIELD_CUSTOM_VALIDATION_EXCEPTION: Employee Pay Period is closed for edits.
      </p>
      <div className="mt-7 flex flex-col-reverse items-center justify-center gap-2 sm:flex-row" data-id="element-65" data-mp="1kiwq6gspb07n">
        <button type="button" onClick={onBack} className="w-full rounded-md border border-ink-200 bg-white px-4 py-2 text-sm font-semibold text-ink-700 transition hover:bg-ink-50 focus:outline-none focus:ring-4 focus:ring-ink-100 sm:w-auto" data-id="element-66" data-mp="1giw6agmu1wt7">
          Back to form
        </button>
        <button type="button" onClick={onRetry} className="inline-flex w-full items-center justify-center gap-1.5 rounded-md bg-brand-600 px-5 py-2 text-sm font-semibold text-white shadow-card transition hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-200 sm:w-auto" data-id="element-67" data-mp="xka1aqo73lk0">
          <RotateCcwIcon className="h-4 w-4" aria-hidden="true" data-id="element-68" data-mp="2myoupoa5rwlu" />
          Retry save
        </button>
      </div>
    </div>;
}